import { Injectable } from '@angular/core';

import 'rxjs/add/operator/toPromise';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

/**
 * Servicio de Reset de caches
 * @author Iecisa
 */
export class ResetService {

    // Subject único y compartido: permite que varios servicios (client-service,
    // policy-service, …) se suscriban al logout. Antes se recreaba en cada
    // observerLogout(), por lo que solo el último suscriptor recibía el evento.
    private logoutChange: Subject<any> = new Subject<any>();

    observerLogout(): Observable<any> {
        return this.logoutChange.asObservable();
    }

    public logout(token: any) {
        this.logoutChange.next(token);
    }

}

